import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import koJson from "./ko.json";
import zhJson from "./zh.json";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  zh: {
    translation: zhJson
  },
  ko: {
    translation: koJson
  }
};

i18n
  // .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // detection: { order: ["navigator", "htmlTag",] },
    resources,
    debug: true,
    lng: `${process.env.REACT_APP_LANG}`,
    fallbackLng: `${process.env.REACT_APP_LANG}`, // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option
  });

export default i18n;